(function () {
  function formatMoney(cents, format) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format || window.Shopify?.money_format || '${{amount}}');
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function updateBar(bar, cart) {
    if (!bar || !cart) return;

    const threshold = parseInt(bar.dataset.shippingThreshold, 10) || 0;
    if (!threshold) return;

    const subtotal = cart.items_subtotal_price || 0;
    const remaining = Math.max(0, threshold - subtotal);
    const progress = Math.min(100, Math.round((subtotal / threshold) * 100));
    const qualified = subtotal >= threshold;
    const moneyFormat = bar.dataset.moneyFormat || window.Shopify?.money_format;

    if (cart.item_count === 0) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;

    bar.classList.toggle('cart-shipping--complete', qualified);
    bar.classList.toggle('cart-drawer__shipping--done', qualified);

    const textEl = bar.querySelector('[data-shipping-text]');
    const fillEl = bar.querySelector('[data-shipping-fill]');
    const amountsEl = bar.querySelector('[data-shipping-amounts]');

    const prefix = bar.dataset.shippingPrefix || '';
    const suffix = bar.dataset.shippingSuffix || '';
    const success = bar.dataset.shippingSuccess || '';

    if (textEl) {
      if (qualified) {
        textEl.textContent = success;
      } else {
        textEl.innerHTML = `${prefix} <strong>${formatMoney(remaining, moneyFormat)}</strong> ${suffix}`;
      }
    }
    if (fillEl) fillEl.style.width = `${progress}%`;
    if (amountsEl) {
      amountsEl.textContent = `${formatMoney(subtotal, moneyFormat)} / ${formatMoney(threshold, moneyFormat)}`;
    }
  }

  function updateShippingLabels(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-cart-shipping-label]').forEach((el) => {
      const threshold = parseInt(el.dataset.shippingThreshold, 10) || 0;
      if (!threshold) return;
      const qualified = (cart.items_subtotal_price || 0) >= threshold;
      const freeLabel = el.dataset.shippingFree || '';
      const calcLabel = el.dataset.shippingCalc || '';
      el.textContent = qualified ? freeLabel : calcLabel;
    });
  }

  window.Track50CartShipping = {
    updateAll(cart) {
      if (!cart) return;
      document.querySelectorAll('[data-free-shipping]').forEach((bar) => updateBar(bar, cart));
      updateShippingLabels(cart);
    },
  };
})();
